import { render, staticRenderFns } from "./FeeIndex.vue?vue&type=template&id=9beeb622"
import script from "./FeeIndex.vue?vue&type=script&lang=js"
export * from "./FeeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports